import {Controller} from "@hotwired/stimulus";

const OPEN_CLASS = "language-menu--open";

export default class extends Controller {
    // workaround to type readonly element
    // this will return the element that was detected as controller
    get el(): HTMLElement {
        return this.element as HTMLElement;
    }

    connect() {
        // Outside Click Detection
        document.addEventListener('click', function (event: any) {
            // @ts-ignore
            const isInsideClick = this.el.contains(event.target);
            if (!isInsideClick) {
                // If Outside Click
                // @ts-ignore
                this.el.classList.remove(OPEN_CLASS);
            }
        }.bind(this));
    }

    toggle() {
        this.el.classList.toggle(OPEN_CLASS)
    }
}
